import React__default from 'react';
import { useOptIns, Utils } from '@grandvisionhq/auth';
import { toast, Loader, ScrollIntoView, Alert } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { toUpdatedOptIns } from './mappers/opt-in-input.js';
import { toServerOptIns } from './mappers/opt-ins-server.js';
import { OptIns } from './OptIns.js';

const OptInsContainer = ()=>{
    const intl = useIntl();
    const onCompleted = React__default.useCallback((operation)=>{
        if (operation === 'MUTATION') {
            toast.success('account.updateOptins.success');
        }
    }, []);
    const onError = React__default.useCallback(({ reason  })=>{
        if (reason === 'MUTATION') {
            toast.failed('account.privacy.updateOptins.errors.general');
        }
    }, []);
    const { optInsFromServer , availableOptIns , isFetching , isUpdating , updateOptIns , fetchError  } = useOptIns({
        onCompleted,
        onError
    });
    const [changedOptIns1, setChangedOptIns] = React__default.useState({});
    const serverOptIns = toServerOptIns(optInsFromServer);
    const handleChange = (changedOptIns)=>{
        setChangedOptIns(changedOptIns);
    };
    const handleSave = ()=>{
        const optInsUpdate = toUpdatedOptIns({
            changedOptIns: changedOptIns1,
            optInsFromServer,
            availableOptIns,
            getLabel: intl.getLabel
        });
        updateOptIns(optInsUpdate);
    };
    if (isFetching) {
        return /*#__PURE__*/ React__default.createElement(Loader, null);
    }
    if (fetchError) {
        return /*#__PURE__*/ React__default.createElement(ScrollIntoView, null, /*#__PURE__*/ React__default.createElement(Alert, {
            type: "error",
            message: intl.getFormattedLabel('account.privacy.fetchOptins.errors.general', {
                parseLink: true
            })
        }));
    }
    const ungroupedOptIns = Utils.ungroupOptIns(availableOptIns);
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small"
    }, intl.getLabel('account.settings.communicationPreferences')), /*#__PURE__*/ React__default.createElement(Text, null, intl.getLabel('account.settings.communicationPreferences.intro')), /*#__PURE__*/ React__default.createElement(OptIns, {
        intl: intl,
        availableOptIns: ungroupedOptIns,
        selectedOptIns: getSelectedOptIns({
            server: serverOptIns,
            client: changedOptIns1,
            availableOptIns: ungroupedOptIns
        }),
        onChange: handleChange,
        onSave: handleSave,
        isUpdating: isUpdating
    }));
};
var OptInsContainer$1 = OptInsContainer;
function getSelectedOptIns({ server , client , availableOptIns  }) {
    let selectedKeys = [];
    if (Object.keys(client).length) {
        // Take selected values from form state when not empty
        selectedKeys = Object.keys(client).reduce((selected, optInName)=>{
            if (!client[optInName].checked) {
                return selected;
            }
            return [
                ...selected,
                optInName
            ];
        }, []);
    } else {
        // Otherwise, take selected values from server state
        selectedKeys = Object.entries(server.optinValues).filter(([_, value])=>value
        ).map(([name])=>name
        );
    }
    return availableOptIns.filter((o)=>selectedKeys.includes(o.value)
    );
}

export { OptInsContainer$1 as default, getSelectedOptIns };
//# sourceMappingURL=OptInsContainer.js.map
